import React from 'react';
import { useTranslation } from 'react-i18next';
import IntroSection from "../../../components/IntroSection/IntroSection";
import WhySection from "../../../components/WhySection/WhySection";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import ComparisonTable from "../../../components/ComparisonTable/ComparisonTable";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import CTA from "../../../components/Constant/cta/CTA";
import ContactFormWithBackground from "../../../components/ContactFormWithBackgroundGray/ContactFormWithBackground";
import SEO from "../../../utils/SEO";

export default function TurkeyResidency() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.turkey-residency.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/turkey-residency"
            />

            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/residency-passport/turkey-residency.png")}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    {/* Setup / Opportunities */}
                    <DetailsSection
                        title={tp('setup.title')}
                        subtitle={tp('setup.subtitle')}
                        items={obj('setup.items')}
                        end={tp('setup.end')}
                    />

                    {/* Benefits */}
                    <FeatureCards
                        title={tp('benefits.title')}
                        subtitle={tp('benefits.subtitle')}
                        features={obj('benefits.items')}
                    />

                    {/* Formation details */}
                    <DetailsSection
                        title={tp('formation.title')}
                        subtitle={tp('formation.subtitle')}
                        items={obj('formation.items')}
                        end={tp('formation.end')}
                    />

                    {/* Residency Options */}
                    <WhySection
                        title={tp('residency.title')}
                        subtitle={tp('residency.subtitle')}
                        blocks={[{ items: obj('residency.items') }]}
                        end={tp('residency.end')}
                    />

                    {/* Banking Features */}
                    <FeatureCards
                        title={tp('banking.title')}
                        subtitle={tp('banking.subtitle')}
                        features={obj('banking.items')}
                        end={tp('banking.end')}
                    />

                    {/* Complete Step-by-Step Timeline */}
                    <TimelineSection
                        title={tp('process.title')}
                        items={obj('process.items')}
                    />

                    {/* Documents You May Need */}
                    <WhySection
                        title={tp('documents.title')}
                        subtitle={tp('documents.subtitle')}
                        blocks={obj('documents.blocks')}
                    />

                    {/* Who This Package Is For */}
                    <FeatureCards
                        title={tp('whoFor.title')}
                        features={obj('whoFor.items')}
                    />

                    {/* Why Combine */}
                    <WhySection
                        title={tp('whyCombine.title')}
                        subtitle={tp('whyCombine.subtitle')}
                        blocks={[{ items: obj('whyCombine.items') }]}
                    />

                    {/* Costs Table */}
                    <ComparisonTable
                        title={tp('costs.title')}
                        columns={["Service", "What's Included"]}
                        data={obj('costs.items')}
                    />

                    {/* FAQ Accordion */}
                    <FAQList 
                        data={obj('faq.items')} 
                        title={tp('faq.title')}
                    />

                    {/* Final CTA Banner */}
                    <CTA 
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />

                    {/* Interactive Contact Form */}
                    <ContactFormWithBackground />
                </div>
            </section>
        </main>
    );
}
